"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var funcParams = "$root,$parent,$parent2,$parent3,$external,$methods,$obj";
exports.default = funcParams;
//# sourceMappingURL=funcParams.js.map